var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"administrativeToken"},[(_vm.isShow)?_c('div',{staticClass:"code"},[_vm._v(_vm._s(_vm.code))]):_c('div',{staticClass:"not-data"},[_c('img',{attrs:{"src":require("./img//not-found.png"),"alt":""}}),_c('span',[_vm._v("暂无权限访问")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }